// extracted by mini-css-extract-plugin
export default {"load":"LoadingScreen_load__OijdI","animate":"LoadingScreen_animate__bAKWM"};